import cx from 'classnames';
import React from 'react';

import { b } from '../cn';

interface Props {
    mix?: string;
    children: React.ReactNode | Array<React.ReactNode>;
}

export const StudentModalFooter = ({ children, mix }: Props) => <div className={cx(b('footer'), mix)}>{children}</div>;
